import React from 'react';
import PageSEO from '@/components/PageSEO';
import { useLocation } from 'react-router-dom';
import { REQUEST_RECEIPT_KEY } from '@/lib/consultationRequest';
import Navbar from '@/components/trinity/Navbar';
import Footer from '@/components/trinity/Footer';
import ConsultThankYou from '@/components/trinity/ConsultThankYou';

export default function ThankYou() {
  const location = useLocation();
  let received = location.state?.requestReceived === true;
  try { const timestamp = Number(sessionStorage.getItem(REQUEST_RECEIPT_KEY)); received = received || (timestamp > 0 && Date.now() - timestamp < 30 * 60 * 1000); } catch { /* No storage: use navigation state only. */ }

  // A page visit is not proof of a lead, appointment, or payment.

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PageSEO title="Your Next Step | Trinity Dental Arts" description="Next steps for your visit request at Trinity Dental Arts in Trinity, Florida. Our team confirms appointments and availability." path="/thank-you" robots="noindex, nofollow" />
      <Navbar />
      <main className="flex-1 flex items-center justify-center py-16 px-4">
        <div className="w-full max-w-xl">
          <ConsultThankYou received={received} />
        </div>
      </main>
      <Footer />
    </div>
  );
}